import { ChangeEvent, FunctionComponent, useCallback, useRef } from 'react'
import { Box, TextField } from '@mui/material'
import { WidgetProps } from '@rjsf/core'
import WithErrorMessage from '../withErrorMessage/WithErrorMessage'
import textareaStyles from './textarea.styles'

const TextareaWidget: FunctionComponent<WidgetProps> = props => {
  const { id, value, onChange, rawErrors } = props
  const inputRef = useRef()

  const styles = textareaStyles()

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement>) => {
      onChange(event.target.value)
    },
    []
  )

  const hasErrors = rawErrors?.length > 0

  return (
    <Box className={styles.root}>
      <WithErrorMessage
        error={hasErrors ? rawErrors[0] : undefined}
        className={styles.helper}
        data-test={`${id}:textarea:error`}
      >
        <TextField
          id={id}
          fullWidth
          error={hasErrors}
          value={value}
          onChange={handleChange}
          InputProps={{
            inputRef: inputRef,
            inputComponent: 'textarea',
            classes: {
              formControl: styles.formControl,
              root: styles.inputRoot,
              input: styles.input,
              error: styles.error,
            },
          }}
        />
      </WithErrorMessage>
    </Box>
  )
}

export default TextareaWidget
